module.exports = __webpack_public_path__ + "img/9.9c88a2ea.png";